import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { analyticsIds } from '../../../../constants/analyticsIds';
import {
  reportsDeselectPreset,
  reportsSelectPreset,
  selectReportsPresets,
  selectReportsStats
} from '../../../../redux/modules/reports';
import PresetReportButton from '../PresetReportButton';
import { presetFilterNames, presetFilterToolMap, presetFilterToolTips } from '../ReportTable/presetFilters';

function PresetReportRow() {
  const dispatch = useDispatch();
  const selectedPresets = useSelector(selectReportsPresets);
  const stats = useSelector(selectReportsStats);

  const applyPresetFilters = name => () => {
    if (selectedPresets.includes(name)) {
      dispatch(reportsDeselectPreset(name));
      return;
    }

    dispatch(reportsSelectPreset(name));
  };

  const getToolTip = useCallback((name, info) => {
    if (name !== presetFilterNames.records) {
      if (selectedPresets.includes(name)) {
        return `${info} Selecting this filter again will remove it from the quick filters.`;
      }

      if (!selectedPresets.includes(presetFilterNames.records) && selectedPresets.length) {
        const pluralFilter = selectedPresets.length >= 2 ? '(s)' : '';
        return `${info} Selecting another quick filter button will add to the already selected filter${pluralFilter}.`;
      }
    }

    return info;
  }, [selectedPresets]);

  return (
    <>
      {presetFilterToolMap.map(filter => (
        <PresetReportButton
          color={filter.color}
          data-analytics-id={filter.analyticsId}
          info={getToolTip(filter.name, filter.info)}
          key={filter.num}
          num={stats[filter.num]}
          selected={selectedPresets.includes(filter.name)}
          title={filter.name}
          transition="0.25s"
          onClick={applyPresetFilters(filter.name)}
        />
      ))}
    </>
  );
}

export default PresetReportRow;
